// Arabisch (ar), dailyApp: zelfde vorm als dailyApp.nl.ts (WP4 dagelijkse schermen).
export const appDailyAr = {
    stars: {
        tab: 'النجوم',
        approvals: 'الموافقة',
        approvalsEmpty: 'لا شيء بانتظار الموافقة.',
        handled: 'تمت معالجتها',
        rewards: 'المكافآت',
        savingFor: 'يدّخر من أجل {goal}',
        noGoal: 'لا يوجد هدف ادخار بعد',
        goalLabel: 'هدف ادخار {name}',
        adjustLabel: 'تعديل نقاط {name}',
        history: 'آخر نقاط {name}',
        info: 'يكسب الأطفال النجوم بإنجاز المهام. هنا ترى لكل طفل ما يمكنه إنفاقه، وما يدّخر من أجله، وما لا يزال بانتظار الموافقة. لإضافة مكافأة أو تعديلها اذهب إلى المكافآت.',
    },
    agenda: {
        title: 'الأجندة',
        rides: 'التوصيلات',
        tools: 'المزيد للأجندة',
        toolsTitle: 'الأجندة',
        calendars: 'ربط التقويمات',
        calendarsHint: 'اعرض هنا مواعيد Google أو Outlook أو iCloud.',
        exportHint: 'كل المواعيد كملف تقويم (.ics).',
        trashHint: 'استعادة المواعيد المحذوفة خلال 30 يومًا.',
    },
    pinboard: {
        title: 'لوحة الإعلانات',
        label: 'أقسام لوحة الإعلانات',
        notes: 'الملاحظات',
        messages: 'الرسائل',
        wishes: 'الأمنيات',
    },
    kids: {
        title: 'الأطفال',
        label: 'أقسام خاصة بالأطفال',
        learning: 'أهداف التعلّم',
        growth: 'النمو',
        school: 'المدرسة',
        filter: 'اختر طفلًا',
        all: 'كل الأطفال',
    },
    chores: {
        label: 'نوع المهام',
        series: 'المهام الثابتة',
        chores: 'الأعمال المنزلية',
    },
    recipes: {
        more: 'تحميل المزيد',
        shown: '{shown} من {total}',
        pick: 'اختر وصفة من القائمة.',
        filter: 'أي الوصفات',
    },
    menu: {
        past: {
            one: 'يوم واحد سابق هذا الأسبوع',
            other: '{count} أيام سابقة هذا الأسبوع',
        },
        showPast: 'إظهار',
        hidePast: 'إخفاء',
        suggestions: 'اقتراحات',
        suggestionsCount: 'اقتراحات ({count})',
        shelfHint: 'اسحب وصفة إلى يوم.',
    },
};
//# sourceMappingURL=dailyApp.ar.js.map